import { BaseObject } from "../../../../shared/baseObject";

export class StoredConfResponseFormat extends BaseObject {
  price?: boolean = false; 
}